import axios from 'axios';
import DataModel from '../models/DataModel.js';
import serviceUtil from './serviceUtil';

let helpers = {
  getProjectGroups(company_id) {
    let request = process.env.REACT_APP_API + '/companies/' + company_id + '/project_groups?current_company=' + localStorage.current_company_id +'for_picker=true';
    return axios({
      method: 'get',
      url: request,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },

  getProjectGoupById(company_id, project_group_id) {
    let request = process.env.REACT_APP_API + '/companies/' + company_id + '/project_groups/' + project_group_id + '?current_company=' + localStorage.current_company_id;

    return axios({
      method: 'get',
      url: request,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },

  createProjectGroup(company_id, group_name, project_ids = []) {
    let request = process.env.REACT_APP_API + '/companies/' + company_id + '/project_groups?current_company=' + localStorage.current_company_id;

    // Create a FormData object to match the format used in Postman
    const formData = new FormData();
    formData.append('project_group[name]', group_name);
  
    // Append project IDs individually like in the form-data array
    project_ids.forEach(id => {
      formData.append('project_ids[]', id);
    });

    return axios({
      method: 'post',
      url: request,
      data: formData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        const errorMessage = error.response.data.name[0];
        DataModel.displayInfoErrorMessage(errorMessage, 4000);
        return serviceUtil.resultForError(error);
      });
  },

  updateProjectGroup(project_group_id, company_id, group_name, project_ids) {
    let request = process.env.REACT_APP_API + '/companies/' + company_id + '/project_groups/' + project_group_id + '?current_company=' + localStorage.current_company_id;

    // Create a FormData object to match the format used in Postman
    const formData = new FormData();
    formData.append('project_group[name]', group_name);
  
    // Append project IDs individually like in the form-data array
    if(project_ids.length > 0){
      project_ids.forEach(id => {
        formData.append('project_ids[]', id);
      });
    }
    else{
      formData.append('project_ids[]', []);
    }

    return axios({
      method: 'patch',
      url: request,
      data: formData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        const errorMessage = error.response.data.name[0];
        DataModel.displayInfoErrorMessage(errorMessage, 4000);
        return serviceUtil.resultForError(error);
      });
  },

  deleteProjectGroup(project_group_id, company_id) {
    let request = process.env.REACT_APP_API + '/companies/' + company_id + '/project_groups/' + project_group_id + '?current_company=' + localStorage.current_company_id;

    return axios({
      method: 'delete',
      url: request,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        const errorMessage = error.response.data.name[0];
        DataModel.displayInfoErrorMessage(errorMessage, 4000);
        return serviceUtil.resultForError(error);
      });
  },
};

export default helpers;




// WEBPACK FOOTER //
// ./src/services/projectGroupService.js